<template>
  <component :is="currentComponent" :key="componentKey" />
  <!-- 自动按设备切换 PC/移动端组件 -->
  </template>

<script>
import Wrongbook from './Wrongbook.vue'
import WrongbookMobile from './WrongbookMobile.vue'
import { isMobile, addResizeListener } from '@/utils/device'

export default {
  name: 'WrongbookIndex',
  data() {
    return {
      isMobileDevice: false,
      removeResizeListener: null,
      componentKey: 'init'
    }
  },
  computed: {
    currentComponent() {
      return this.isMobileDevice ? WrongbookMobile : Wrongbook
    }
  },
  created() {
    this.isMobileDevice = isMobile()
  },
  mounted() {
    let rafId = null
    const onResize = () => {
      if (rafId) return
      rafId = requestAnimationFrame(() => {
        const next = isMobile()
        if (next !== this.isMobileDevice) {
          this.isMobileDevice = next
          this.componentKey = next ? 'm' : 'pc'
        }
        rafId = null
      })
    }
    this.removeResizeListener = addResizeListener(onResize)
  },
  beforeDestroy() {
    if (this.removeResizeListener) {
      this.removeResizeListener()
      this.removeResizeListener = null
    }
  }
}
</script>

<style scoped>
</style>

